import Avatar from '@sdk/components/avatar/Avatar';
import Text12 from '@sdk/components/ui/typography/Text12';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Row from '@sdk/components/ui/spacing/Row';
import { UserPositionsText } from '@sdk/components/ui/UserPositionsText/UserPositionsText';
import { UserLocationsText } from '@sdk/components/ui/UserLocationsText/UserLocationsText';

import { GROUP_TITLE_CHARACTER_LIMIT } from '@web/newsfeed/constants';
import { Article } from '@web/newsfeed/types/Article';
import { RelativeDateString } from '@web/components/RelativeDateString/RelativeDateString';

import {
  HeaderWrapper,
  AuthorDataWrapper,
  ArticleDataWrapper,
  AuthorDataColumn,
  ArticleHeaderText,
} from './articleHeader.styles';

type Props = {
  article: Article;
};

export const ArticleHeader = ({ article }: Props) => {
  const { user } = article;

  return (
    <HeaderWrapper>
      <AuthorDataWrapper>
        <Avatar user={user} />
        <AuthorDataColumn>
          <ArticleHeaderText semiBold themeColor={ThemeColorType.primary}>
            {user.fullname}
          </ArticleHeaderText>
          <Row>
            <Text12>
              <UserPositionsText
                positions={user.positions}
                charLimit={GROUP_TITLE_CHARACTER_LIMIT}
                fontSize={12}
                lineHeight={19}
              />
              {user.locations?.length && user.positions?.length ? ' • ' : null}
              <UserLocationsText
                locations={user.locations}
                charLimit={GROUP_TITLE_CHARACTER_LIMIT}
                themeColor={ThemeColorType.primaryText}
                fontSize={12}
                lineHeight={19}
              />
            </Text12>
          </Row>
        </AuthorDataColumn>
      </AuthorDataWrapper>
      <ArticleDataWrapper>
        <ArticleHeaderText semiBold themeColor={ThemeColorType.primary}>
          {article.page.name}
        </ArticleHeaderText>
        <RelativeDateString
          date={article.posted}
          lineHeight={19}
          themeColor={ThemeColorType.primaryText}
          fontSize={12}
        />
      </ArticleDataWrapper>
    </HeaderWrapper>
  );
};
